import { call, put, takeEvery } from "redux-saga/effects";
import fetchService from "../../../lib/fetchService";
import { FETCH_FILE_VERSIONS_REQUEST, fetchFileVersionError, fetchFileVersionSuccess } from "./action";
import config from "../../../config";

const requestSaga = function*({ payload, meta }) {
  const { fileUuid, fileToken } = payload;

  const url = `${config.urls.STORAGE_SERVICE}/fileversions/${fileUuid}`;
  const data = { token: fileToken };

  try {
    const response = yield call(fetchService.get, url, data);
    if (response.ok) {
      const responseData = yield call(() => response.json());
      const defaultAction = fetchFileVersionSuccess(fileUuid, responseData);
      if (!meta || !meta.onSuccess) {
        yield put(defaultAction);
      } else {
        yield put({
          ...defaultAction,
          meta: meta.onSuccess,
        });
      }
    } else {
      const statusCode = response.status;
      const defaultAction = fetchFileVersionError(fileUuid, new Error(`Request failed with error ${statusCode}!`));
      if (!meta || !meta.onFailure) {
        yield put(defaultAction);
      } else {
        yield put({
          ...defaultAction,
          meta: meta.onFailure,
        });
      }
    }
  } catch (e) {
    const defaultAction = fetchFileVersionError(fileUuid, e);
    if (!meta || !meta.onFailure) {
      yield put(defaultAction);
    } else {
      yield put({
        ...defaultAction,
        meta: meta.onFailure,
      });
    }
  }
};

export default function*() {
  yield takeEvery(FETCH_FILE_VERSIONS_REQUEST, requestSaga);
}
